const womenDenimSizes = ["25", "26", "27", "28", "29", "30", "31", "32"];
const womenSizes = ["XS", "S", "M", "L", "XL"];
const menWaistSizes = ["28", "30", "31", "32", "33", "34", "36"];
const menSizes = ["S", "M", "L", "XL", "XXL"];

const createProduct = ({ id, ...product }) => {
  const image = `/img/product-${String(id).padStart(2, "0")}.jpg`;

  return {
    id,
    ...product,
    image,
    images: [image],
  };
};

const productData = [
  createProduct({
    id: 1,
    name: "BAARLY HIGH WAIST BARREL JEANS",
    gender: "women",
    category: "jeans",
    price: 188,
    size: womenDenimSizes,
    colors: ["Mid Blue", "Washed Black"],
    colorHex: ["#63778a", "#303033"],
    material: "100% regenerative cotton denim",
    description:
      "A high-rise barrel jean with a softly curved leg and cropped ankle. The structured denim settles into a relaxed shape that feels modern without losing everyday ease.",
    features: ["High-rise waist", "Curved barrel leg", "Five-pocket construction"],
    attributes: {
      Fit: "Relaxed barrel",
      Waist: "High rise",
      Length: "Ankle",
      Care: "Wash at 30°C inside out",
    },
    tags: ["favorite", "bestseller", "detoxdenim", "barrel"],
    badge: "BESTSELLER",
    rating: 4.8,
    reviews: 84,
  }),
  createProduct({
    id: 2,
    name: "ENIJAA HIGH WAIST WIDE JEAN",
    gender: "women",
    category: "jeans",
    price: 188,
    size: womenDenimSizes,
    colors: ["Light Stone", "Rinse Blue"],
    colorHex: ["#aeb8bd", "#394c63"],
    material: "79% organic cotton, 20% recycled cotton, 1% elastane",
    description:
      "Long, clean and easy through the leg, ENIJAA balances a close high waist with generous volume. A subtle stretch keeps the authentic denim character comfortable from morning to night.",
    features: ["Floor-grazing wide leg", "Comfort stretch", "Recycled metal trims"],
    attributes: {
      Fit: "Wide",
      Waist: "High rise",
      Length: "Full",
      Care: "Wash at 30°C with similar colors",
    },
    tags: ["favorite", "new", "detoxdenim", "wide"],
    badge: "NEW",
    rating: 4.7,
    reviews: 52,
  }),
  createProduct({
    id: 3,
    name: "MAIRAA MOM JEAN",
    gender: "women",
    category: "jeans",
    price: 178,
    size: womenDenimSizes,
    colors: ["Authentic Blue", "Ecru"],
    colorHex: ["#657f98", "#e4dfd0"],
    material: "100% GOTS-certified organic cotton",
    description:
      "A dependable mom jean cut close at the waist and tapered toward the ankle. The non-stretch organic denim develops an individual patina the more it is worn.",
    features: ["Tapered leg", "Rigid denim hand feel", "Low-impact wash"],
    attributes: {
      Fit: "Mom",
      Waist: "High rise",
      Length: "Cropped",
      Care: "Wash less and air dry",
    },
    tags: ["favorite", "detoxdenim", "mom"],
    badge: "DETOXDENIM",
    rating: 4.6,
    reviews: 113,
  }),
  createProduct({
    id: 4,
    name: "HAAYI LOW WAIST BAGGY JEAN",
    gender: "women",
    category: "jeans",
    price: 188,
    size: womenDenimSizes,
    colors: ["Vintage Blue", "Grey Wash"],
    colorHex: ["#71859a", "#686967"],
    material: "80% organic cotton, 20% post-consumer recycled cotton",
    description:
      "Designed to sit low on the hips, HAAYI has a roomy leg and an easy break at the shoe. The balanced recycled-cotton blend gives this relaxed silhouette real denim substance.",
    features: ["Low-rise waist", "Loose baggy leg", "Recycled cotton blend"],
    attributes: {
      Fit: "Baggy",
      Waist: "Low rise",
      Length: "Long",
      Care: "Cold wash inside out",
    },
    tags: ["new", "favorite", "detoxdenim", "loose"],
    badge: "NEW",
    rating: 4.7,
    reviews: 46,
  }),
  createProduct({
    id: 5,
    name: "THAALINA MID WAIST DENIM SHORT",
    gender: "women",
    category: "shorts",
    price: 98,
    size: womenDenimSizes,
    colors: ["Sun Bleach", "Deep Indigo"],
    colorHex: ["#b8c4ca", "#293b54"],
    material: "100% organic cotton denim",
    description:
      "An easy mid-rise denim short with a straight, unforced leg and a clean finished hem. Dense organic cotton keeps the silhouette crisp while softening beautifully with wear.",
    features: ["Mid-rise waist", "Relaxed thigh", "Finished hem"],
    attributes: {
      Fit: "Relaxed",
      Waist: "Mid rise",
      Length: "Upper thigh",
      Care: "Machine wash at 30°C",
    },
    tags: ["favorite", "summer", "detoxdenim"],
    badge: "ONLINE EXCLUSIVE",
    rating: 4.5,
    reviews: 31,
  }),
  createProduct({
    id: 6,
    name: "ASTRAEAAS WIDE JEAN",
    gender: "women",
    category: "jeans",
    price: 208,
    size: womenDenimSizes,
    colors: ["Raw Indigo", "Soft Black"],
    colorHex: ["#263a56", "#292929"],
    material: "100% regenerative cotton selvedge denim",
    description:
      "A refined wide jean built from weighty regenerative-cotton denim. Precise topstitching and a long uninterrupted leg make ASTRAEAAS an elevated foundation for simple outfits.",
    features: ["Premium selvedge denim", "Wide straight leg", "Tonal stitching"],
    attributes: {
      Fit: "Wide straight",
      Waist: "High rise",
      Length: "Full",
      Care: "Wash sparingly on a gentle cycle",
    },
    tags: ["premium", "favorite", "detoxdenim", "wide"],
    badge: "LIMITED",
    rating: 4.9,
    reviews: 27,
  }),
  createProduct({
    id: 7,
    name: "LEJAANI HIGH WAIST SLIM JEAN",
    gender: "women",
    category: "jeans",
    price: 188,
    size: womenDenimSizes,
    colors: ["Clean Blue", "Black Rinse"],
    colorHex: ["#49647e", "#202124"],
    material: "98% organic cotton, 2% recycled elastane",
    description:
      "A streamlined high-waist jean that follows the body without feeling restrictive. The resilient organic-cotton stretch denim retains its shape through repeat wear.",
    features: ["Slim leg", "Shape-retaining stretch", "Laser-finished wash"],
    attributes: {
      Fit: "Slim",
      Waist: "High rise",
      Length: "Regular",
      Care: "Wash at 30°C and line dry",
    },
    tags: ["detoxdenim", "slim", "core"],
    badge: "CORE STYLE",
    rating: 4.6,
    reviews: 95,
  }),
  createProduct({
    id: 8,
    name: "TILLAA MID WAIST SKINNY JEANS",
    gender: "women",
    category: "jeans",
    price: 188,
    size: womenDenimSizes,
    colors: ["Dark Blue", "True Black"],
    colorHex: ["#283c55", "#171717"],
    material: "91% organic cotton, 7% recycled polyester, 2% elastane",
    description:
      "A clean skinny jean with a comfortable mid rise and flexible recovery. TILLAA is shaped to move, with a dark responsible wash that works across seasons.",
    features: ["Second-skin fit", "Four-way comfort stretch", "Dark rinse finish"],
    attributes: {
      Fit: "Skinny",
      Waist: "Mid rise",
      Length: "Regular",
      Care: "Cold wash and reshape damp",
    },
    tags: ["detoxdenim", "skinny", "core"],
    badge: "CORE STYLE",
    rating: 4.7,
    reviews: 132,
  }),
  createProduct({
    id: 9,
    name: "CAARUNUS LINO PANT",
    gender: "women",
    category: "pants",
    price: 178,
    size: womenSizes,
    colors: ["Sand", "Ink Navy"],
    colorHex: ["#c5b9a1", "#252d39"],
    material: "100% European linen",
    description:
      "An airy linen trouser with a softly tailored waistband and relaxed straight leg. Natural texture and breathable fibers give CAARUNUS an uncomplicated summer character.",
    features: ["Breathable linen weave", "Front pleats", "Side-seam pockets"],
    attributes: {
      Fit: "Relaxed straight",
      Waist: "Mid rise",
      Length: "Full",
      Care: "Gentle wash and steam to shape",
    },
    tags: ["favorite", "linen", "summer"],
    badge: "NATURAL FIBER",
    rating: 4.8,
    reviews: 38,
  }),
  createProduct({
    id: 10,
    name: "LINEN BLEND KAAYUA PANT",
    gender: "women",
    category: "pants",
    price: 218,
    size: womenSizes,
    colors: ["Oat", "Graphite"],
    colorHex: ["#d4cbb9", "#4b4a48"],
    material: "55% European linen, 45% TENCEL™ Lyocell",
    description:
      "Fluid tailoring meets natural texture in KAAYUA. A linen and lyocell blend drapes cleanly from the high waist and stays cool against the skin.",
    features: ["Linen-lyocell blend", "Double front pleat", "Wide flowing leg"],
    attributes: {
      Fit: "Tailored wide",
      Waist: "High rise",
      Length: "Full",
      Care: "Gentle cycle at 30°C",
    },
    tags: ["new", "linen", "tailoring"],
    badge: "NEW",
    rating: 4.6,
    reviews: 19,
  }),
  createProduct({
    id: 11,
    name: "BARREL LEG TWILL PANT",
    gender: "women",
    category: "pants",
    price: 178,
    size: womenSizes,
    colors: ["Khaki", "Midnight"],
    colorHex: ["#a59b82", "#1f252b"],
    material: "97% organic cotton twill, 3% elastane",
    description:
      "A workwear-inspired twill pant with a sculpted barrel leg and neat waist. A hint of stretch softens the sturdy organic-cotton cloth for comfortable everyday movement.",
    features: ["Curved seam shaping", "Soft brushed twill", "Utility back pockets"],
    attributes: {
      Fit: "Barrel",
      Waist: "High rise",
      Length: "Ankle",
      Care: "Wash at 30°C inside out",
    },
    tags: ["new", "barrel", "organic-cotton"],
    badge: "NEW",
    rating: 4.5,
    reviews: 22,
  }),
  createProduct({
    id: 12,
    name: "ICONIC Å TARJAA T-SHIRT",
    gender: "women",
    category: "t-shirts",
    price: 65,
    size: womenSizes,
    colors: ["Off White", "Raspberry"],
    colorHex: ["#ece9df", "#a33850"],
    material: "100% GOTS-certified organic cotton jersey",
    description:
      "The signature Å tee in a soft, substantial organic-cotton jersey. TARJAA has an easy straight shape, a ribbed crew neck and a graphic made with water-based inks.",
    features: ["Relaxed straight cut", "Water-based chest print", "Soft rib neckline"],
    attributes: {
      Fit: "Relaxed",
      Neckline: "Crew",
      Weight: "Midweight",
      Care: "Wash inside out at 30°C",
    },
    tags: ["favorite", "iconic", "organic-cotton", "tops"],
    badge: "ICONIC Å",
    rating: 4.9,
    reviews: 146,
  }),
  createProduct({
    id: 13,
    name: "JAAMES T-SHIRT",
    gender: "men",
    category: "t-shirts",
    price: 40,
    size: menSizes,
    colors: ["White", "Black", "Sage"],
    colorHex: ["#f2f0e9", "#181818", "#788271"],
    material: "100% GOTS-certified organic cotton jersey",
    description:
      "A clean everyday crew-neck tee made from smooth organic cotton. JAAMES is regular through the chest with enough room to layer, designed as a durable wardrobe constant.",
    features: ["Regular fit", "Reinforced neckline", "Pre-washed soft finish"],
    attributes: {
      Fit: "Regular",
      Neckline: "Crew",
      Weight: "Lightweight",
      Care: "Machine wash at 30°C",
    },
    tags: ["favorite", "bestseller", "organic-cotton", "core"],
    badge: "BESTSELLER",
    rating: 4.8,
    reviews: 214,
  }),
  createProduct({
    id: 14,
    name: "MAARKOS WAFFLE T-SHIRT",
    gender: "men",
    category: "t-shirts",
    price: 78,
    size: menSizes,
    colors: ["Ecru", "Forest"],
    colorHex: ["#ddd6c4", "#34483d"],
    material: "100% organic cotton waffle knit",
    description:
      "A textured tee knitted in a breathable organic-cotton waffle. The slightly relaxed silhouette gives the familiar crew neck a more tactile, considered finish.",
    features: ["Dimensional waffle texture", "Relaxed shoulder", "Ribbed trims"],
    attributes: {
      Fit: "Relaxed",
      Neckline: "Crew",
      Weight: "Midweight",
      Care: "Wash gently and dry flat",
    },
    tags: ["favorite", "new", "organic-cotton"],
    badge: "NEW",
    rating: 4.7,
    reviews: 42,
  }),
  createProduct({
    id: 15,
    name: "AASHTON DENIM JACKET",
    gender: "men",
    category: "jackets",
    price: 208,
    size: menSizes,
    colors: ["Mid Indigo", "Washed Black"],
    colorHex: ["#506982", "#363638"],
    material: "100% regenerative cotton denim",
    description:
      "AASHTON updates the trucker jacket with a clean, roomy profile and regenerative-cotton denim. Layer it as an overshirt now and let the wash gain character over time.",
    features: ["Relaxed trucker fit", "Metal button closure", "Four functional pockets"],
    attributes: {
      Fit: "Relaxed",
      Closure: "Button front",
      Weight: "13 oz denim",
      Care: "Wash only when needed",
    },
    tags: ["favorite", "detoxdenim", "outerwear"],
    badge: "DETOXDENIM",
    rating: 4.8,
    reviews: 63,
  }),
  createProduct({
    id: 16,
    name: "ARAAMO FLANNEL SHIRT",
    gender: "men",
    category: "shirts",
    price: 128,
    size: menSizes,
    colors: ["Rust Check", "Pine Check"],
    colorHex: ["#8c5c48", "#3d5149"],
    material: "100% organic cotton brushed flannel",
    description:
      "A warm brushed flannel shirt with a balanced check and relaxed silhouette. ARAAMO works open as a light layer or buttoned as a soft everyday shirt.",
    features: ["Double-brushed flannel", "Chest patch pocket", "Recycled buttons"],
    attributes: {
      Fit: "Relaxed",
      Collar: "Button-down",
      Weight: "Midweight",
      Care: "Wash at 30°C and line dry",
    },
    tags: ["favorite", "organic-cotton", "layering"],
    badge: "FAVORITE",
    rating: 4.6,
    reviews: 51,
  }),
  createProduct({
    id: 17,
    name: "PULL-ON TAPERED JEANS",
    gender: "men",
    category: "jeans",
    price: 168,
    size: menWaistSizes,
    colors: ["Rinse Blue", "Faded Black"],
    colorHex: ["#324a65", "#4a4949"],
    material: "82% organic cotton, 16% recycled cotton, 2% elastane",
    description:
      "Denim structure with pull-on comfort. This tapered jean uses an elasticized back waist and a flexible lower-impact fabric while keeping a clean fly-front appearance.",
    features: ["Elasticized back waist", "Tapered leg", "Comfort-stretch denim"],
    attributes: {
      Fit: "Tapered",
      Waist: "Mid rise",
      Length: "Regular",
      Care: "Wash inside out at 30°C",
    },
    tags: ["new", "favorite", "detoxdenim", "tapered"],
    badge: "NEW",
    rating: 4.7,
    reviews: 35,
  }),
  createProduct({
    id: 18,
    name: "WORDMARK RELAXED SWEATSHIRT",
    gender: "men",
    category: "sweatshirts",
    price: 128,
    size: menSizes,
    colors: ["Heather Grey", "Cobalt"],
    colorHex: ["#aaa9a5", "#31558a"],
    material: "100% organic cotton loopback jersey",
    description:
      "A generous loopback sweatshirt finished with a restrained tonal wordmark. The organic-cotton fabric is substantial outside and softly looped inside for year-round layering.",
    features: ["Relaxed drop shoulder", "Tonal embroidery", "Ribbed cuffs and hem"],
    attributes: {
      Fit: "Relaxed",
      Neckline: "Crew",
      Weight: "Heavyweight",
      Care: "Wash at 30°C inside out",
    },
    tags: ["favorite", "iconic", "organic-cotton", "sweats"],
    badge: "ICONIC Å",
    rating: 4.8,
    reviews: 87,
  }),
  createProduct({
    id: 19,
    name: "ICONIC Å BAASTI MEL SWEATPANT",
    gender: "men",
    category: "sweatpants",
    price: 145,
    size: menSizes,
    colors: ["Melange Grey", "Black"],
    colorHex: ["#9f9e9b", "#1b1b1b"],
    material: "100% organic cotton brushed sweat",
    description:
      "A substantial sweatpant with a relaxed tapered leg and signature Å detail. The brushed organic-cotton interior makes BAASTI MEL especially soft while staying structured.",
    features: ["Elastic drawcord waist", "Brushed inner face", "Embroidered Å mark"],
    attributes: {
      Fit: "Relaxed tapered",
      Waist: "Adjustable",
      Length: "Regular",
      Care: "Wash at 30°C with similar colors",
    },
    tags: ["favorite", "iconic", "organic-cotton", "sweats"],
    badge: "ICONIC Å",
    rating: 4.9,
    reviews: 104,
  }),
  createProduct({
    id: 20,
    name: "STRUCTURED JACKET",
    gender: "men",
    category: "jackets",
    price: 188,
    size: menSizes,
    colors: ["Warm Sand", "Black"],
    colorHex: ["#b8a88d", "#1d1d1d"],
    material: "60% organic cotton, 40% recycled cotton canvas",
    description:
      "A precise everyday jacket cut from sturdy cotton canvas. Minimal seams, a pointed collar and a boxy body give the workwear reference a quiet contemporary shape.",
    features: ["Dense cotton canvas", "Boxy workwear cut", "Concealed inner pocket"],
    attributes: {
      Fit: "Boxy",
      Closure: "Button front",
      Weight: "Heavyweight",
      Care: "Gentle machine wash",
    },
    tags: ["new", "favorite", "recycled-cotton", "outerwear"],
    badge: "NEW",
    rating: 4.6,
    reviews: 24,
  }),
  createProduct({
    id: 21,
    name: "AASTER CHINO PANT",
    gender: "men",
    category: "pants",
    price: 128,
    size: menWaistSizes,
    colors: ["Olive", "Stone"],
    colorHex: ["#62644e", "#b7ae9c"],
    material: "97% organic cotton twill, 3% recycled elastane",
    description:
      "A pared-back chino with a comfortable straight taper and a smooth organic-cotton hand. AASTER moves easily between relaxed shirting, tees and smarter layers.",
    features: ["Straight tapered leg", "Soft peached twill", "Clean welt back pockets"],
    attributes: {
      Fit: "Straight tapered",
      Waist: "Mid rise",
      Length: "Regular",
      Care: "Machine wash at 30°C",
    },
    tags: ["core", "organic-cotton", "chino"],
    badge: "CORE STYLE",
    rating: 4.7,
    reviews: 79,
  }),
  createProduct({
    id: 22,
    name: "MAARIO KNITTED POLO SHIRT",
    gender: "men",
    category: "knitwear",
    price: 128,
    size: menSizes,
    colors: ["Cream", "Dark Navy"],
    colorHex: ["#e3ddcc", "#202a38"],
    material: "100% organic cotton fine knit",
    description:
      "A fine-gauge knitted polo with a soft open collar and clean hem. MAARIO brings subtle texture to warm-weather dressing without feeling formal.",
    features: ["Fine-gauge knit", "Open polo collar", "Fully fashioned seams"],
    attributes: {
      Fit: "Regular",
      Collar: "Open polo",
      Weight: "Lightweight",
      Care: "Wash gently and dry flat",
    },
    tags: ["favorite", "new", "organic-cotton", "knitwear"],
    badge: "NEW",
    rating: 4.8,
    reviews: 29,
  }),
  createProduct({
    id: 23,
    name: "MAARKOS GMT DYE SMILE T-SHIRT",
    gender: "men",
    category: "t-shirts",
    price: 78,
    size: menSizes,
    colors: ["Garment-Dyed Clay", "Garment-Dyed Blue"],
    colorHex: ["#996c59", "#63788b"],
    material: "100% organic cotton heavy jersey",
    description:
      "A heavyweight organic tee individually garment dyed for nuanced color. A small smile motif and relaxed shoulders lend MAARKOS a quietly playful finish.",
    features: ["Individual garment dye", "Water-based smile print", "Heavyweight jersey"],
    attributes: {
      Fit: "Relaxed",
      Neckline: "Crew",
      Weight: "Heavyweight",
      Care: "Wash separately before first wear",
    },
    tags: ["new", "organic-cotton", "graphic"],
    badge: "GARMENT DYED",
    rating: 4.5,
    reviews: 18,
  }),
  createProduct({
    id: 24,
    name: "MAAKX RELAXED TAPERED JEAN",
    gender: "men",
    category: "jeans",
    price: 168,
    size: menWaistSizes,
    colors: ["Classic Blue", "Charcoal"],
    colorHex: ["#4f6982", "#464748"],
    material: "100% recycled and organic cotton denim",
    description:
      "A roomy five-pocket jean that narrows cleanly below the knee. MAAKX combines relaxed proportions with a lower-impact cotton blend for a dependable everyday fit.",
    features: ["Relaxed top block", "Tapered lower leg", "Recycled cotton content"],
    attributes: {
      Fit: "Relaxed tapered",
      Waist: "Mid rise",
      Length: "Regular",
      Care: "Wash less, cold and inside out",
    },
    tags: ["favorite", "bestseller", "detoxdenim", "tapered"],
    badge: "BESTSELLER",
    rating: 4.8,
    reviews: 121,
  }),
];

export default productData;
